import { render, staticRenderFns } from "./MultiAcctNoSfxHelpList.vue?vue&type=template&id=60b78aae&"
import script from "./MultiAcctNoSfxHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiAcctNoSfxHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports